import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import useVersionInfo from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

import { FetchDatasetParams } from '../../types';

import { v4DocumentationResponse } from './types';

const fetchV4DatasetDocumentation = async (params: FetchDatasetParams) => {
  const { data } = await api.get(`/web/v4/uprs/${params.dataset_id}/documentation`, { params });

  return data;
};

const useV4DatasetDocumentation = (id?: string) => {
  const { ver: version, system_model } = useVersionInfo();
  return useQuery<v4DocumentationResponse, AxiosError>({
    queryKey: ['documentationV4', id, version, system_model],
    queryFn: () => fetchV4DatasetDocumentation({ dataset_id: id as string, version, system_model }),
    enabled: isV4Release(version) && !!id,
    retry: false,
  });
};

export default useV4DatasetDocumentation;
